import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import { isFunction } from '@utiljs/is';
import warning from 'warning';
import { Provider } from './context';

var RadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: 'value' in _this.props ? _this.props.value : _this.props.defaultValue
    };

    _this.handleChange = function (v) {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        warning(false, 'Roo RadioGroup: 请注意，从 1.0.0 开始，返回参数改为对应的 Radio `value` 值');
        onChange(v);
      }
    };

    _this.handleRadioGroupChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          propsValue = _this$props.value;

      if (disabled) {
        return;
      }

      if (propsValue !== undefined) {
        _this.handleChange(value);
      } else {
        _this.setState({
          value: value
        }, function () {
          _this.handleChange(value);
        });
      }
    }; // handleRadioGroupChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const {
    //         disabled,
    //         onChange,
    //     } = this.props;
    //     if (disabled) {
    //         return;
    //     }
    //     const radioValue: string = event.target.value;
    //     if (!('value' in this.props)) {
    //         this.setState({
    //             value: radioValue,
    //         });
    //     }
    //     // 复制出常用的事件属性
    //     const {
    //         checked,
    //         nodeName,
    //         nodeType,
    //         value,
    //     } = event.target;
    //     const e = {
    //         ...event,
    //         target: {
    //             ...event.target,
    //             value,
    //             nodeName,
    //             nodeType,
    //             checked,
    //             type: 'radioGroup'
    //         }
    //     };
    //     if (onChange) {
    //         onChange(e);
    //     }
    // }


    _this.renderChild = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          disabled = _this$props2.disabled;
      var value = _this.state.value;
      return React.Children.map(children, function (child) {
        var checked = value === (child.props && child.props.value);
        var childDisabled = child.props && child.props.disabled;
        return /*#__PURE__*/React.cloneElement(child, {
          disabled: disabled ? true : childDisabled,
          checked: checked,
          onChange: _this.handleRadioGroupChange
        });
      });
    };

    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          children = _this$props3.children;
      var value = this.state.value;
      var contextValue = {
        onRadioGroupChange: this.handleRadioGroupChange,
        value: value,
        disabled: disabled
      };
      return /*#__PURE__*/React.createElement(Provider, {
        value: contextValue
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-radio-group ".concat(className)
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return RadioGroup;
}(React.Component);

RadioGroup.rooName = 'RRadioGroup';
RadioGroup.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
RadioGroup.defaultProps = {
  defaultValue: '',
  disabled: false,
  className: '',
  onChange: undefined
};
polyfill(RadioGroup);
export default RadioGroup;